<template>
  <div>
    <a @click="showOcrDialog = true">上传证件识别</a>

    <insurance-ocr-dialog :show.sync="showOcrDialog" @submit="orcSubmit"></insurance-ocr-dialog>
  </div>
</template>


<script>
import utils from '@/libs/utils';
import insuranceOcrDialog from '@/pages/insurance/components/insurance-ocr-dialog';

export default {
  props: {
    insuranceData: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    insuranceOcrDialog,
  },
  data() {
    return {
      showOcrDialog: false,
    };
  },
  computed: {
    // 投保人支持的证件类型
    supportPassport() {
      // 1身份证 2护照
      return this.insuranceData.applicant_type_set && this.insuranceData.applicant_type_set.includes(2);
    },
    supportIdCard() {
      // 1身份证 2护照
      return this.insuranceData.applicant_type_set && this.insuranceData.applicant_type_set.includes(1);
    },
  },
  methods: {
    orcSubmit(applicantList) {
      applicantList = applicantList.map((item) => {
        // 不支持护照
        if (!this.supportPassport && item.card_type === 2) {
          // 只支持身份证，把护照的选择清空
          item.card_type = '';
          item.card_code = '';
        } else if (!this.supportIdCard && item.card_type === 1) { // 不支持身份证
          // 只支持护照，把身份证的选择清空
          item.card_type = '';
          item.card_code = '';
        }
        return {
          ...item,
          ename: item.cname ? PinyinHelper.convertToPinyinString(item.cname, '#', PinyinFormat.WITHOUT_TONE)
            .split('#')
            .map(pin => pin.substring(0, 1).toUpperCase() + pin.substring(1))
            .join('') : '',
          relation_id: this.insuranceData.is_self_insure ? 1 : undefined,
        };
      });

      
      // 最后一条数据是否为空，为空则删除
      const lastInsurance = this.insuranceData.insurants[this.insuranceData.insurants.length - 1];
      const lastInsurantIsEmpty = Object.keys(lastInsurance).every(key => lastInsurance[key] !== 0 && !lastInsurance[key]);
      // 当前长度,最后一条为空时，计算需要减一，因为最后会把最后一条删了
      const currLength = lastInsurantIsEmpty ? this.insuranceData.insurants.length - 1 : this.insuranceData.insurants.length;
      if (currLength + applicantList.length > this.insuranceData.max_people) {
        return utils.msg.warning(`该商品单次最多${this.insuranceData.max_people}名被保人，当前只可再上传${this.insuranceData.max_people - (currLength - (lastInsurantIsEmpty ? 1 : 0))}张图片，请检查后重新上传`);
      }

      this.showOcrDialog = false;
      this.$emit('ocr-submit', applicantList);
    },
  },
};

</script>


<style lang="less" scoped>
a{
  color: #599FFF;
  font-size: 14px;
}
</style>






// WEBPACK FOOTER //
// src/pages/insurance/insuranceOrder/insuranceInfo/components/left-insurance-form/components/theInsured-list/components/ocr-upload-btn.vue